
export const KEYWORD_TYPE = {
	KEYWORD: 'id_keyword',
 	KEYWORD_CATEGORY: 'id_keyword_category',
 	KEYWORD_BRAND: 'id_keyword_brand',
 	KEYWORD_TYPE: 'id_keyword_type'
}